import { Injectable } from '@angular/core';
import { ComponentStore } from '@ngrx/component-store';
import { Observable } from 'rxjs';

import { MAX_USE_ADD_COMPARTMENT } from 'src/environments/runtime';

export interface iRearLoadingState {
  maxAddCompartment: number;
  addCompartmentCount: number;
  spacesAvailable: number;
  positions: string[];
}

const DEFAULT_REAR_LOADING_STATE: iRearLoadingState = {
  maxAddCompartment: Number(MAX_USE_ADD_COMPARTMENT),
  addCompartmentCount: 0,
  spacesAvailable: 0,
  positions: [],
};

@Injectable({ providedIn: 'root' })
export class RearLoadingStore extends ComponentStore<iRearLoadingState> {
  private static _instance: RearLoadingStore;
  private sessionPositions: string[] = [];

  constructor() {
    super(DEFAULT_REAR_LOADING_STATE);

    if (!RearLoadingStore._instance) {
      RearLoadingStore._instance = this;
    }
    return RearLoadingStore._instance;
  }

  readonly store$: Observable<iRearLoadingState> = this.select((state) => state);

  readonly decreaseSpacesAvailable = this.updater((state) => {
    return {
      ...state,
      spacesAvailable: state.spacesAvailable - 1,
    };
  });

  readonly resetAddCompartmentCount = this.updater((state, addCompartmentCount: number) => {
    return {
      ...state,
      addCompartmentCount,
    };
  });

  readonly updateSpacesAvailable = this.updater((state, spacesAvailable: number) => {
    return {
      ...state,
      spacesAvailable,
    };
  });

  updateSessionPositions(positions: string[]): void {
    this.sessionPositions = [...positions];
    this.patchState({ positions: [...positions] });
  }

  getSessionPositions(): string[] {
    return [...this.sessionPositions];
  }
}
